import React, { useEffect, useState } from 'react';
import { BpMatrixClient } from '../utils/matrixClient';
import { MatrixContext, type MatrixContextType } from './MatrixContext';
import { matrixStatusStore } from './stores/MatrixStatusStore';
import { matrixUserStore } from './stores/MatrixUserStore';
import { powerLevelsStoreManager } from './stores/PowerLevelsStore';
import { roomsStore } from './stores/RoomsStore';
import { roomTimelineStoreManager } from './stores/RoomTimelineStore';

interface MatrixProviderProps {
  children: React.ReactNode;
}

export function MatrixProvider({ children }: MatrixProviderProps) {
  const [contextValue, setContextValue] = useState<MatrixContextType>({
    client: null,
  });

  useEffect(() => {
    BpMatrixClient.instance().then((client) => {
      if (!client) return;

      // Initialisiere alle Matrix Stores mit dem Client
      roomsStore.setClient(client);
      roomTimelineStoreManager.setClient(client);
      matrixStatusStore.setClient(client);
      powerLevelsStoreManager.setClient(client);
      matrixUserStore.setClient(client);
      setContextValue({
        client,
      });
    });
  }, []);

  return <MatrixContext.Provider value={contextValue}>{children}</MatrixContext.Provider>;
}
